import translate from '../../../i18n'
import {
  IPublicPrelaunchLessonDescriptionDto,
  PrelaunchConfirmationStatusEnum,
} from '../../../pages/prelaunch-organization-forms-container/share-types'
import { Button, Descriptions, Popconfirm, Space, Tag } from 'antd'

interface IProps {
  data: IPublicPrelaunchLessonDescriptionDto[]
  isExpired: boolean
  uniqueId: string
  organizationName: string
  onDelete: (id: number) => void
}

const PrelaunchLessonDescriptions = (props: IProps) => {
  const { data, isExpired, uniqueId, organizationName, onDelete } = props

  const getStudioStatusTagColor = (status: string) => {
    switch (status) {
      case PrelaunchConfirmationStatusEnum.SUBMITTED:
        return 'green'
      case PrelaunchConfirmationStatusEnum.CONFIRMED:
        return 'blue'
      default:
        return 'blue'
    }
  }

  return (
    <Space orientation="vertical" style={{ width: '100%' }} size={16}>
      {data.map(item => (
        <Descriptions column={{ xs: 1, sm: 2 }}>
          <Descriptions.Item label={translate('name')}>
            <Space>
              {item.name}
              {!isExpired && (
                <a
                  href={`/public/prelaunch-organization-form/${uniqueId}/lesson-descriptions/${item.id}/${organizationName}/duplicate`}
                >
                  {translate('duplicate')}
                </a>
              )}
              {!isExpired && item.status === PrelaunchConfirmationStatusEnum.SUBMITTED && (
                <>
                  <a
                    href={`/public/prelaunch-organization-form/${uniqueId}/lesson-descriptions/${item.id}/${organizationName}/edit`}
                  >
                    {translate('edit')}
                  </a>
                  <Popconfirm
                    title="删除课程模版"
                    description="删除后不可恢复，确认删除吗？"
                    onConfirm={() => onDelete(item.id)}
                  >
                    <Button type="link" danger>
                      {translate('delete')}
                    </Button>
                  </Popconfirm>
                </>
              )}
            </Space>
          </Descriptions.Item>
          <Descriptions.Item label={translate('lessonDescription.status')}>
            <Tag color={getStudioStatusTagColor(item.status)}>{item.status}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label={translate('lessonDescription.duration')}>
            {item.duration}分钟
          </Descriptions.Item>
          <Descriptions.Item label={translate('lessonDescription.credits')}>
            {item.credits}点数
          </Descriptions.Item>
        </Descriptions>
      ))}
    </Space>
  )
}

export default PrelaunchLessonDescriptions
